import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const VideoCameraFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function VideoCameraFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M0 16V8c0-2.21 1.79-4 4-4h12v16H4c-2.21 0-4-1.79-4-4ZM18 16.33V7.67L24 4v16l-6-3.67Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default VideoCameraFilled;